import type { ButtonHTMLAttributes, InputHTMLAttributes, PropsWithChildren } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...values: Array<string | false | null | undefined>) => twMerge(clsx(values));

export function Button({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={cn(
        "inline-flex min-h-12 items-center justify-center rounded-xl bg-emerald-800 px-5 py-3 font-semibold text-white shadow-sm transition hover:bg-emerald-900 focus:outline-none focus:ring-4 focus:ring-emerald-200 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export function SecondaryButton({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <Button
      className={cn(
        "border border-emerald-800 bg-white text-emerald-900 hover:bg-emerald-50",
        className,
      )}
      {...props}
    />
  );
}

export function Card({ className, children }: PropsWithChildren<{ className?: string }>) {
  return (
    <section
      className={cn("rounded-2xl border border-stone-200 bg-white p-5 shadow-sm", className)}
    >
      {children}
    </section>
  );
}

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        "min-h-12 w-full rounded-xl border border-stone-300 bg-white px-4 text-lg text-stone-900 outline-none transition focus:border-emerald-700 focus:ring-4 focus:ring-emerald-100",
        className,
      )}
      {...props}
    />
  );
}

export function Badge({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full bg-emerald-100 px-3 py-1 text-sm font-semibold text-emerald-900",
        className,
      )}
    >
      {children}
    </span>
  );
}
